import { useState } from 'react';
import {
  UI_SCALE_MAX,
  UI_SCALE_MIN,
  useSettingsStore,
  type OverheadLabelMode,
} from '../../store/settingsStore';
import { Segmented } from './Segmented';

const LABEL_OPTIONS: { value: OverheadLabelMode; label: string }[] = [
  { value: 'all', label: 'All' },
  { value: 'bars', label: 'Bars only' },
  { value: 'off', label: 'Off' },
];

const toPercent = (scale: number) => Math.round(scale * 100);

/** Options → Interface: UI scale, overhead labels, your own name. */
export function InterfaceTab() {
  const uiScale = useSettingsStore((s) => s.uiScale);
  const setUiScale = useSettingsStore((s) => s.setUiScale);
  const overheadLabels = useSettingsStore((s) => s.overheadLabels);
  const setOverheadLabels = useSettingsStore((s) => s.setOverheadLabels);
  const showOwnName = useSettingsStore((s) => s.showOwnName);
  const setShowOwnName = useSettingsStore((s) => s.setShowOwnName);
  // The scale resizes every rem, this slider included: dragging edits a draft, and the scale
  // applies on release so the thumb stays under the cursor.
  const [draft, setDraft] = useState<number | null>(null);
  const percent = draft ?? toPercent(uiScale);
  const commit = () => {
    if (draft === null) return;
    setUiScale(draft / 100);
    setDraft(null);
  };

  return (
    <>
      <label className="option-row">
        <span className="option-label">UI scale</span>
        <span className="option-slider">
          <input
            type="range"
            min={toPercent(UI_SCALE_MIN)}
            max={toPercent(UI_SCALE_MAX)}
            step={5}
            value={percent}
            aria-valuetext={`${percent}%`}
            onChange={(e) => setDraft(Number(e.target.value))}
            onPointerUp={commit}
            onKeyUp={commit}
            onBlur={commit}
          />
          <output>{percent}%</output>
        </span>
      </label>
      <Segmented
        label="Overhead labels"
        options={LABEL_OPTIONS}
        value={overheadLabels}
        onChange={setOverheadLabels}
      />
      <label className="option-check">
        <input
          type="checkbox"
          checked={showOwnName}
          onChange={(e) => setShowOwnName(e.target.checked)}
        />
        Show my own name
      </label>
    </>
  );
}
